import axios from 'axios';

const initialState = () => ({
  currentHtml: '',
  versionOutdated: false,
});

const state = initialState();

const actions = {
  initCurrentHtml({ commit }) {
    return fetchIndexHtml().then((html) => commit('SET_CURRENT_HTML', html));
  },
  checkIfVersionIsOutdated({ commit, state }) {
    return fetchIndexHtml().then((html) => commit('SET_VERSION_OUTDATED', state.currentHtml !== html));
  },
};

const mutations = {
  SET_CURRENT_HTML(state, html) {
    state.currentHtml = html;
  },
  SET_VERSION_OUTDATED(state, versionOutdated) {
    state.versionOutdated = versionOutdated;
  },
};

const getters = {
  currentHtml: (state) => state.currentHtml,
  versionOutdated: (state) => state.versionOutdated,
};

function fetchIndexHtml() {
  return axios.get('/').then((response) => response.data);
}

export const appVersionDetector = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
